import uirouter from '@uirouter/angularjs';
import common from 'app/modules/common';

export default angular
  .module('app.holding.dashboard.bars', [
    uirouter,
    common,
  ])
  .name;

require('./directives/available-unregistered-balance/available-unregistered-balance');
require('./directives/bar-list/bar-list');
require('./directives/bars-balance/bars-balance');
require('./directives/bars-more-menu/bars-more-menu');
require('./directives/registered-bars/registered-bars');
require('./directives/registration-recap/registration-recap');
require('./directives/redemptions-list/redemptions-list');
require('./filters/product-name');
require('./filters/product-metal');
require('./services/bars');
require('./states/bars');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bars/index.js